import React from 'react';
import ReactDOM from 'react-dom';

import ContentAudience from  '@/components/elements/contentaudience/ContentAudience';
import ContentAudienceProvider from  '@/components/elements/contentaudience/ContentAudienceContext';

const ContentAudiencePortal = () =>  {

    let appId: string = '';
    let contentExistsInMultipleLocations: boolean = false;
    let isOrgAdmin: boolean = false;
    let isEditor: boolean = false;
    let contentIsArchived: boolean = false;

    // Container ref
    const targetContainer = document.getElementById('react-content-audience-container');
    
    // Dont load if container doesnt exist
    if (targetContainer === null){
        return null;
    }else {
        appId = targetContainer.getAttribute('data-appid') as string
        contentExistsInMultipleLocations = targetContainer.getAttribute('data-contentExistsInMultiplePlaces') === 'True'
        isOrgAdmin = targetContainer.getAttribute('data-isOrgAdmin') === 'True'
        isEditor = targetContainer.getAttribute('data-isEditor') === 'True'
        contentIsArchived = targetContainer.getAttribute('data-contentIsArchived') === 'True'
    }


    if (isOrgAdmin || isEditor) {
        return ReactDOM.createPortal(
            <ContentAudienceProvider appId={appId} existsInMultipleLocations={contentExistsInMultipleLocations} isOrgAdmin={isOrgAdmin} isEditor={isEditor}>
                <ContentAudience contentIsArchived={contentIsArchived}/>
            </ContentAudienceProvider>, targetContainer
        );
    }
}

export default ContentAudiencePortal;